module.exports = __webpack_public_path__ + "static/img/Man Mini Bags.d6be520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Man Mini Bags.jpg
// module id = jVvs
// module chunks = 1